import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { restrictLabel } from './categoriesUtils';
import { Checkbox } from '../../../../components/checkbox/Checkbox';
import { CategoryType } from '../../../search.types';
import { MaterialIcon } from '../../../../components/material-icon/MaterialIcon';
import styles from './categories_lib.module.scss';

export const CategoriesToggler: FC<{
  onToggle: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isOpen: boolean;
}> = ({ onToggle, isOpen }) => (
  <button
    data-test-id="toggler"
    className={styles.accordion}
    type="button"
    onClick={onToggle}
  >
    {!isOpen && <OpenLabel />}
    {isOpen && <CloseLabel />}
  </button>
);

export const OpenLabel = () => (
  <>
    <MaterialIcon name="keyboard_arrow_down" className={styles.accordionIcon} />
    <span>
      <FormattedMessage id="search/components/aside-filters/categories/CategoriesLib.tsx/1" />
    </span>
  </>
);

export const CloseLabel = () => (
  <>
    <MaterialIcon name="keyboard_arrow_up" className={styles.accordionIcon} />
    <span>
      <FormattedMessage id="search/components/aside-filters/categories/CategoriesLib.tsx/2" />
    </span>
  </>
);

type ItemProps = {
  category: CategoryType;
  children: React.ReactNode;
  isSelected: boolean;
  isExpanded: boolean;
  onSelect: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onExpand: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const CategoriesNodeItem: FC<ItemProps> = ({
  category,
  children,
  isSelected,
  onSelect,
  onExpand,
  isExpanded,
}) => {
  const isMax = Math.floor(category.count) !== category.count;
  return (
    <div>
      <div className={styles.actions}>
        <button
          data-test-id="category-expand"
          className={styles.collapse}
          type="button"
          title={restrictLabel(category.categoryName)}
          onClick={onExpand}
        >
          {category.hasSub ? (
            <>
              {isExpanded ? (
                <MaterialIcon name="arrow_drop_down" className={styles.arrow} />
              ) : (
                <MaterialIcon name="arrow_right" className={styles.arrow} />
              )}
            </>
          ) : (
            <span className={styles.noArrow} />
          )}
        </button>
        <button
          data-test-id="category-select"
          type="button"
          onClick={onSelect}
          className={styles.checkbox}
        >
          <Checkbox checked={isSelected} data-test-id="checkbox" />
          <span className={styles.checkboxLabel}> {category.categoryName}</span>
          <span>{`${Math.floor(category.count)}${
            isMax ? '\u00A0+' : ''
          }`}</span>
        </button>
      </div>

      {isExpanded && children}
    </div>
  );
};
